const changeOverTimeType = {
    COMPUTE_CHANGE: 'COMPUTE_CHANGE',
    COMPUTE_CHANGE_PERCENT: 'COMPUTE_CHANGE_PERCENT',
    COMPUTE_CHANGE_COMPOSITION: 'COMPUTE_CHANGE_COMPOSITION',
};

export default changeOverTimeType;
